// extracted by mini-css-extract-plugin
module.exports = {"phoneComponent":"PhoneNumberInput_phoneComponent__ZUxYj"};